<template>
    <el-row :gutter="15" style="margin: 10px">
        <el-col :span="3">
            <el-input v-on:keyup.native.enter="search" size="mini" :clearable="true" placeholder="订单号"
                      v-model.trim="id">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
        </el-col>

        <el-col :span="3">
            <el-input v-on:keyup.native.enter="search" size="mini" :clearable="true" placeholder="款号"
                      v-model.trim="baseId">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
        </el-col>
        <el-col :span="1">
            <el-button :loading="searchLoading" @click="search" type="primary" size="mini">搜索</el-button>
        </el-col>
        <el-col :span="2">
            <el-button icon="el-icon-refresh" :loading="refreshLoading" @click="refresh" type="primary" size="mini">刷新
            </el-button>
        </el-col>
        <slot>

        </slot>
        <el-col :span="10" v-if="countData" class="row-tags">
            <div v-for="data in  countData.dataArr">
                <el-tag effect="plain" :type="data.type" size="mini">
                    <span class="text-info">{{ data.tagName }}</span>
                    <el-icon v-if="data.loading" class="el-icon-loading"></el-icon>
                    <el-link @click="tagClick(data)" :underline="false" v-else :type="data.type">{{
                        data.count }}
                    </el-link>
                </el-tag>
            </div>
        </el-col>

    </el-row>
</template>

<script>
    import setting from "../../plugins/setting";

    export default {
        name: "OrderSearch",
        props: {
            searchUrl: {
                type: String,
                required: false,
                default: `${setting.data.orderListUrl}?ordering=id`
            },
            refreshUrl: {
                type: String,
                required: false,
                default: `${setting.data.orderListUrl}?ordering=id`
            },
            handleSuccess: {
                type: Function,
                required: true,
            },
            handleReFresh: {
                type: Function,
                required: true,
            },
            countData: {
                type: Object,
                required: false

                /*
                *** countData should like this
                *
                * {
                *   countTagsUrl: '',    // 加载/刷新所有 countData 的接口
                *   dataArr: [
                *       {
                *           count: 0,
                *           tagName:'',
                *           loading: false,
                *           url: url,                   // 点击 countTag 加载刷新当前的 orders
                *           countKey: 'finished',       // 从 countTagsUrl 接口中获得的数据 key
                *           type:'success',             // tag 的类型，可以从 success,danger 中选择
                *       },
                *       ...
                *   ],
                *   addOrderResponse:()=>{}   // 这是一个函数，用来处理加载 countTag 标签获取的响应
                * }
                * */
            },
        },
        data() {
            return {
                id: '',
                baseId: '',
                searchLoading: false,
                refreshLoading: false,
            }
        },
        methods: {
            /**
             * 刷新数量标签
             */
            refreshCountTags() {
                this.countData.dataArr.forEach(tagData => {
                    tagData['loading'] = true
                })
                this.$getRequest(this.countData.countTagsUrl)
                    .then(response => {
                        this.countData.dataArr.forEach(tagData => {
                            tagData['loading'] = false
                            tagData['count'] = response.data[tagData.countKey]
                        })
                    })
            },

            /**
             * 点击标签
             * @param data
             */
            tagClick(data) {
                data.loading = true
                this.$getRequest(data.url)
                    .then(response => {
                        data.loading = false
                        this.handleReFresh(response)
                    })
            },

            search() {
                this.searchLoading = true
                const params = {}
                if (this.id) {
                    params['id'] = parseInt(this.id.substring(this.id.length - 5))
                }

                if (this.baseId) {
                    params['base_id'] = this.baseId
                }
                this.$getRequest(this.searchUrl, params)
                    .then(response => {
                        this.searchLoading = false
                        this.handleSuccess(response)
                    })
                    .catch(error => {
                        this.searchLoading = false
                    })
            },
            refresh() {
                this.refreshCountTags()
                this.$emit('beforeRefresh')
                this.refreshLoading = true
                this.$getRequest(this.refreshUrl)
                    .then(response => {
                        this.refreshLoading = false
                        this.handleReFresh(response)
                    })
                    .catch(error => {

                    })
            }
        },
        created() {
            this.refreshCountTags()
        }
    }
</script>

<style scoped>
    .row-tags div {
        float: left;
        margin: 0 4px;
    }
</style>